module.exports = __webpack_public_path__ + "static/media/02-login.b1d5abeb.png";